<!--
 * @Description: 侧边菜单导航
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-10-26 16:35:13
-->
<template>
  <div class="menu" @mousewheel.stop>
    <el-scrollbar>
      <el-menu
        class="el-menu-vertical-demo"
        :default-active="activeMenu"
        background-color="#4D4E5D"
        text-color="#c9c9c9"
        active-text-color="#ffffff"
        mode="vertical"
        :collapse-transition="false"
        :collapse="opened"
      >
        <!-- <div v-for="item in routes" :key="item.path">
          <side-menu-item :item="item" :base-path="item.path"></side-menu-item>
        </div> -->
        <page-link to="/dashbord">
          <el-menu-item index="/dashbord">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
        </page-link>
        <div v-for="item in menuList" :key="item.path">
          <side-menu-item :item="item" :base-path="item.path"></side-menu-item>
        </div>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { getMenu } from '@/api/college'
import to from 'await-to'
import SideMenuItem from './SideMenuItem'
import { mapGetters } from 'vuex'
import PageLink from './Link'
export default {
  components: { SideMenuItem, PageLink },
  data() {
    return {
      routes: this.$router.options.routes,
      clientCode: '260bb55c-47e3-48d0-bd8c-c2cf1ce5',
      menuList: [],
    }
  },
  computed: {
    ...mapGetters(['opened', 'menuType']),
    activeMenu() {
      return this.$route.path
    },
  },
  created() {
    this.getMenuData()
  },
  methods: {
    async getMenuData() {
      const [res, err] = await to(getMenu({ clientCode: this.clientCode }))
      if (err) return this.$message.warning(err.msg)
      this.menuList = res.data
    },
  },
}
</script>
